var exports = {
  "w": "xaee3c4fa--3747bd--header",
  "r": "xaee3c4fa--3747bd--body",
};

module.exports = exports;
